import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule, AlertListModule } from '@xref/ngx';

import { EmailValidatorModule } from '../../components/email-validator/email-validator.module';
import { RequiredValidatorModule } from '../../components/required-validator/required-validator.module';
import { OmniLoaderModule } from '../../components/omni-loader/omni-loader.module';
import { ForgottenPasswordComponent } from './forgotten-password.component';
import { ButtonModule} from '@xref/xref-lib';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RequiredValidatorModule,
        RouterModule,
        EmailValidatorModule,
        TranslateModule,
        OmniLoaderModule,
        AlertListModule,
        ButtonModule
    ],
    declarations: [ForgottenPasswordComponent]
})
export class ForgottenPasswordModule {}
